export class KeyValueStatelessObservable<T> {
  private observers: Map<string | number, ((value: T) => void)[]>;

  constructor() {
    this.observers = new Map();
  }

  subscribe(key: string | number, observer: (value: T) => void) {
    if (!this.observers.has(key)) {
      this.observers.set(key, []);
    }
    this.observers.get(key)?.push(observer);
  }

  unsubscribe(key: string | number, observer: (value: T) => void) {
    if (this.observers.has(key)) {
      let subscriptions: ((value: T) => void)[] = this.observers.get(key)!;
      if (subscriptions?.length) {
        subscriptions = subscriptions.filter((storedObserver: (value: T) => void) => storedObserver !== observer);
        if (subscriptions?.length) {
          this.observers.set(key, subscriptions);
        } else {
          this.observers.delete(key);
        }
      }
    }
  }

  notify(key: string | number, value: T) {
    if (this.observers.has(key)) {
      this.observers.get(key)?.forEach((storedObserver) => storedObserver(value));
    }
  }
}